import { Button, Grid } from "@material-ui/core";
import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./genai.css";

export default function FeedbackCoach() {
  const [genaiaccess, setgenaiaccess] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          alt="background-img"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
          alt="main-background-img"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to="/departments">
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              Generative AI for Business Conversation
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div>
          <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp">
              <h2>Crucial Chatbot</h2>
              <img
                className="exp-img"
                src="/assets/images/crucial.jpg"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/crucial-chatbot">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>Diversity and Inclusivity</h2>
              <img
                className="exp-img"
                src="/assets/images/diversity1.jpg"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/diversity">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>
                Critical Conversation <br /> Simulation{" "}
              </h2>
              <img
                className="exp-img"
                src="/assets/images/critical-convo1.jpg"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/critical-conversation">
                <p>Open</p>
              </Link>
            </div>
          </div>
          <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp" style={{ padding: "1rem 1rem" }}>
              <h2>Prompt Engineering Chatbot</h2>
              <img
                className="exp-img"
                src="/assets/images/ibold.jpg"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/prompt-eng-department">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>Configurable Chatbot</h2>
              <img
                className="exp-img"
                src="/assets/images/whisper.jpg"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/configurable-chatbot">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>
                Critical Conversation <br /> Simulation Cot{" "}
              </h2>
              <img
                className="exp-img"
                src="/assets/images/critical-convo1.jpg"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/critical-conversation-cot">
                <p>Open</p>
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}
